import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlService } from './url.service';
import { OrganizationDto } from 'app/@types/dto/organization-dto.model';
import { OnboardingDto } from 'app/@types/dto/onboarding-dto.model';
import { BYPASS_ERROR } from 'app/auth/helpers';
import { UserInfoDto } from 'app/@types/dto/user-info-dto.model';
import { UserClaims } from 'app/@types/dto/user-claims.model';

@Injectable({
    providedIn: 'root',
})
export class UserHttpService {
    constructor(
        private http: HttpClient,
        private urlService: UrlService,
    ) {}

    updateOrganization(orgId: string, org: OrganizationDto): Observable<OrganizationDto> {
        return this.http.put<OrganizationDto>(this.urlService.updateOrganization(orgId), org);
    }

    initUser(onboarding: OnboardingDto, clientName: string): Observable<string> {
        return this.http.post<string>(this.urlService.postRegister(clientName), onboarding, {
            context: new HttpContext().set(BYPASS_ERROR, true),
        });
    }

    logout(): Observable<void> {
        return this.http.post<void>(this.urlService.postLogout(), {});
    }

    getAvailableOrganization(): Observable<OrganizationDto[]> {
        return this.http.get<OrganizationDto[]>(this.urlService.getAvailableOrganization());
    }

    /**
     * Fetch the user claims, optionally scoped to an organization. Org-scoped fields
     * (`userRole`, `organization_entities`, …) are only populated by the backend when
     * an organizationId is passed.
     */
    getUserClaims(organizationId?: string): Observable<UserClaims> {
        return this.http.get<UserClaims>(this.urlService.getUserClaimsUrl(organizationId));
    }

    getUserByOrganization(orgId: string): Observable<UserInfoDto[]> {
        return this.http.get<UserInfoDto[]>(this.urlService.getUserByOrganization(orgId));
    }

    addUserToScan(user: UserInfoDto) {
        return this.http.put(this.urlService.addUserToScan(), user);
    }

    updateUser(user: UserInfoDto) {
        return this.http.put<UserInfoDto>(this.urlService.updateUser(), user);
    }

    updateCognitoUser(user: UserInfoDto) {
        return this.http.put<UserInfoDto>(this.urlService.updateCognitoUser(), user);
    }

    removeUser(orgId: string, userId: string) {
        return this.http.delete(this.urlService.removeUser(orgId, userId));
    }
}
